import { NavLink } from 'react-router-dom'
import React from 'react'
import { Menu } from 'antd'
import {
  HomeOutlined,
  TeamOutlined,
  ApartmentOutlined,
  DownOutlined,
  SettingFilled,
  SnippetsOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignTopOutlined,
  DollarOutlined,
  DollarCircleOutlined,
  PhoneOutlined,
  AuditOutlined,
  PictureOutlined,
} from '@ant-design/icons'
import DropdownUI from '@components/ui/DropDownUI/DropdownUi'
import { routersPath } from '@router/routes-path'

export interface ITabs {
  title: JSX.Element | Element
  pages: routersPath[]
}

export const adminTabs: ITabs[] = [
  {
    title: (
      <NavLink to={routersPath.MAIN_PAGE}>
        <HomeOutlined />
        Статистика
      </NavLink>
    ),
    pages: [routersPath.MAIN_PAGE],
  },
  {
    title: (
      <DropdownUI
        menu={
          <Menu
            items={[
              {
                key: routersPath.USERS,
                label: (
                  <NavLink to={routersPath.USERS}>
                    <span>Пользователи</span>
                  </NavLink>
                ),
                icon: <TeamOutlined />,
              },
              {
                key: routersPath.CRMS,
                label: (
                  <NavLink to={routersPath.CRMS}>
                    <span>CRM</span>
                  </NavLink>
                ),
                icon: <ApartmentOutlined />,
              },
              {
                key: routersPath.TARIFFS,
                label: (
                  <NavLink to={routersPath.TARIFFS}>
                    <span>Тарифы</span>
                  </NavLink>
                ),
                icon: <AuditOutlined />,
              },
              {
                key: routersPath.BILLING,
                label: (
                  <NavLink to={routersPath.BILLING}>
                    <span>Оплаты</span>
                  </NavLink>
                ),
                icon: <DollarCircleOutlined />,
              },
              {
                key: routersPath.BANNERS,
                label: (
                  <NavLink to={routersPath.BANNERS}>
                    <span>Баннеры</span>
                  </NavLink>
                ),
                icon: <PictureOutlined />,
              },
            ]}
          />
        }
      >
        <span>
          <SettingFilled />
          Настройки
          <DownOutlined style={{ marginLeft: '5px' }} />
        </span>
      </DropdownUI>
    ),
    pages: [routersPath.USERS, routersPath.CRMS, routersPath.BILLING],
  },
  {
    title: (
      <DropdownUI
        menu={
          <Menu
            items={[
              {
                key: routersPath.REPORTS,
                label: (
                  <NavLink to={routersPath.REPORTS}>
                    <span>Отчеты</span>
                  </NavLink>
                ),
                icon: <SnippetsOutlined />,
              },
              {
                key: routersPath.INCOMES,
                label: (
                  <NavLink to={routersPath.INCOMES}>
                    <span>Приходы</span>
                  </NavLink>
                ),
                icon: <VerticalAlignBottomOutlined />,
              },
              {
                key: routersPath.EXPENSES,
                label: (
                  <NavLink to={routersPath.EXPENSES}>
                    <span>Расходы</span>
                  </NavLink>
                ),
                icon: <VerticalAlignTopOutlined />,
              },
              {
                key: routersPath.SALARY,
                label: (
                  <NavLink to={routersPath.SALARY}>
                    <span>Зарплаты</span>
                  </NavLink>
                ),
                icon: <DollarOutlined />,
              },
              {
                key: routersPath.TELEPHONY,
                label: (
                  <NavLink to={routersPath.TELEPHONY}>
                    <span>Телефония crm</span>
                  </NavLink>
                ),
                icon: <PhoneOutlined />,
              },
              {
                key: routersPath.PHONE_OPERATOR,
                label: (
                  <NavLink to={routersPath.PHONE_OPERATOR}>
                    <span>Телефония</span>
                  </NavLink>
                ),
                icon: <PhoneOutlined />,
              },
            ]}
          />
        }
      >
        <span>
          <SnippetsOutlined />
          Отчеты
          <DownOutlined style={{ marginLeft: '5px' }} />
        </span>
      </DropdownUI>
    ),
    pages: [
      routersPath.REPORTS,
      routersPath.REPORT,
      routersPath.INCOMES,
      routersPath.EXPENSES,
      routersPath.SALARY,
      routersPath.TELEPHONY,
      routersPath.PHONE_OPERATOR,
    ],
  },
]
